<template>
    <div>
        <b-form-group :id="groupId" v-bind="$attrs">
            <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <div v-if="isAllowEdit && !isUpdatable">
                <v-select :components="{OpenIndicator, Deselect}"  :ref="feedbackId" :label="optionsLabel" append-to-body :options="options" :value="selectedValue" :filterable="true" @search:focus="onFocus" @input="setSelected" @search="searchData" @open="openData" v-bind="$attrs"></v-select>
                <b-form-invalid-feedback :id="feedbackId" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''"  v-else-if="isUpdatable">
                <span>{{ selectedValue != null && selectedValue != "" ? selectedValue : "-" }}</span>
                <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                {{ selectedValue }}
            </div>
        </b-form-group>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" triggers="manual" :title="label" placement="bottomleft">
            <v-select :ref="feedbackId" :label="optionsLabel" append-to-body :options="options" :value="popoverSelectedValue" :filterable="true" @search:focus="onFocus" @input="setPopupSelected" @search="searchData" @open="openData" v-bind="$attrs">
                <template #selected-option>
                    <app-long-text :maxLength="18" :mdMaxLength="22" :text="popoverSelectedValue != '' && popoverSelectedValue != null ? popoverSelectedValue : ''" />
                </template>
            </v-select>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button size="sm" @click="popoverShow = false" class="btn-default-white">Cancel</b-button>
                <b-button @click="setSelected" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<script>
export default {
    props: ["model", "id", "name", "selected", "errorMessage", "options", "state", "isEditable", "isUpdatable", "optionsLabel", "optionsKey", "change", "label", "isRequired", "onSelectMethod", "isSelectMethodExists","nolabel", "returnValue", "reloadData"],
    data() {
        return {
            OpenIndicator: {
                render: createElement => createElement('b-icon-chevron-down',  {class: {'btn-transparent': true}}),
            },
            Deselect: {
                render: createElement => createElement('b-icon-x',  {class: {'btn-transparent': true, 'btn-grey' : true}}),
            },
            labelStr: this.label,
            value: "",
            selectedValue: this.selected,
            inputModel: this.model,
            isConfirmMessageBox: false,
            groupId : "fieldset-" + this.id,
            feedbackId : "input-" + this.id + "-live-feedback",
            firstOptions : [],
            popoverValue: "",
            popoverSelectedValue: this.selected,
            popoverShow: false,
            isSubmitted: false,
            isRestoreOption : false,
            optionValue : this.options,
        }
    }, 
    methods: {
        setPopupSelected(value) {
            this.popoverValue = value;
            this.popoverSelectedValue = value != null ? value[this.optionsLabel] : null;
        },
        setSelected(value) {
            // this.isRestoreOption = false;
            this.optionValue = this.options;
            
            if (this.popoverShow) {
                value = this.popoverValue;
            }
            if (!this.isSelectMethodExists) {
                this.inputModel = value != null ? value[this.optionsKey] : null;
                this.inputModel = this.inputModel;
                this.selectedValue = value != null ? value[this.optionsLabel] : null;
                this.$emit('update:model', this.inputModel);
                this.$emit("change");
            } else {
                //this.$refs[this.feedbackId].$refs.search.blur();
                this.$emit("onSelectMethod", value, this.$refs[this.feedbackId].$refs.search);
                this.isConfirmMessageBox = true;
            }
            this.popoverShow = false;
        },
        onPopoverShow() {
            this.popoverSelectedValue = this.selectedValue;
            this.popoverShow = true;
        },
        searchData(search, loading) {
            this.$emit("input", search);
        },
        openData(search, loading) {
            if (this.optionValue == null || this.optionValue.length <= 0 || this.reloadData == true) {
                this.$emit("input", search);
            } else if (this.firstOptions != null && this.firstOptions.length > 0) {
                this.optionValue = this.firstOptions;
            }
        },
        onFocus() {
            if (this.isConfirmMessageBox) {
                this.$refs[this.feedbackId].$refs.search.blur();
                this.isConfirmMessageBox = false;
            }
        }
    },
    mounted() {
        if ((this.selectedValue == null || this.selectedValue == undefined) && (this.model != null && this.model != undefined && this.model != "")) {
            var option = this.optionValue.filter(item => item[this.optionsKey] == this.model);
            var newValue = option.length > 0 ? option[0][this.optionsLabel] : "";
            this.selectedValue = newValue;
        }
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch: {
        model(newValue) {
            this.inputModel = newValue;
            if (newValue == null || newValue == '') {
                this.selectedValue = '';
            } else {
                var option = this.optionValue.filter(item => item[this.optionsKey] == newValue);
                var newValue = option.length > 0 ? option[0][this.optionsLabel] : "";
                this.selectedValue = newValue;
            }
        },
        options(newValue,oldValue){
            this.oldOption = newValue;
            if ((this.model != null && this.model != undefined && this.model != "") && !this.isRestoreOption) {
                this.optionValue = oldValue;
                this.isRestoreOption = true
            }   
        },
        selected(newValue) {
            this.selectedValue = newValue;
        },
        label : function(val) {
            this.labelStr = val;
        },
        loading(newValue, oldValue) {
            if (!oldValue && newValue) {
                if (this.firstOptions.length <= 0) {
                    this.firstOptions = this.optionValue;
                }
            }
        },
        returnValue(newValue, oldValue) {
            if (this.isUpdatable && this.isSubmitted) {
                console.log(typeof newValue);
                if (newValue && typeof newValue == "boolean") {
                    this.popoverShow = false;
                    this.isSubmitted = false;
                } else {
                    this.popoverShow = true;
                }
            }
        },
        popoverShow(newValue) {
            if (!newValue) {
                if (this.isSubmitted) {
                    this.popoverShow = true;
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
::v-deep.vs__dropdown-toggle {
    background: #ffffff !important;
}
</style>